import * as ip from "../utils/ip";

module.exports = class ipv6 {
    getState() {
        return new Promise(function (resolve) {
            ip.getV6Data().then(() => {
                resolve("ok");
            }).catch(() => {
                resolve("fail");
            });
        });
    }
};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ipv6.js